module.exports = __webpack_public_path__ + "static/media/rrPizzaBG.ec8bc1ac.png";